import React, { useState, useRef, useEffect } from "react";

export default function withClickOutSideMobile(WrappedComponent) {
  const Component = (props) => {
    const [openMenu, setOpenMenu] = useState(false);

    const ref = useRef();

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (!ref.current?.contains(event.target)) {
          setOpenMenu(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    return <WrappedComponent open={openMenu} setOpen={setOpenMenu} ref={ref} />;
  };

  return Component;
}
